import ReviewOverlay from "@/components/base/ReviewOverlay";
import {breakpoints} from "@/styles/sizes";
import Image from "next/image";
import Link from "next/link";
import styled from "styled-components";
import ArrowDownGreenIcon from '/public/images/green_down.svg'
import {getColor} from "@/styles/ThemeConfig";
import Breadcrumbs from "@/components/other/Breadcrumbs";
import CustomDropdown from "@/components/other/CustomDropdown";
import {HeroCarousel} from "@/components/other/HeroCarousel";
import Stars from "@/components/base/Stars";
import ForceSSRLink from "@/components/other/ForceSSRLink";

const SocialLink = styled(ForceSSRLink)`
    width: 40px;
    height: 40px;

    display: flex;
    justify-content:center;
    align-items:center;
    transition: 0.3s ease;

    :hover{
        background-color: rgba(0,0,0,0.05);
    }
`
const VideoWrapper = styled.div`
    height: 650px;
    @media only screen and (${breakpoints.mobile}) {
        height: 250px;
    }
`;


const Container = styled.div`
    margin-top:150px;
    @media only screen and (${breakpoints.mobile}) {
        margin-top: ${props => props?.$isEmbeddedPage ? '0px' : '150px'};
    }
`;


const MainContentWrapper = styled.div`
    @media only screen and (${breakpoints.mobile}) {
        padding: ${props => props?.$isEmbeddedPage ? '20px' : '0px'};    
    }
`;

export default function TourHeroSection({
                                            reviewOverlayData,
                                            backgroundImageUrl,
                                            heroMedia,
                                            title,
                                            socialLinks,
                                            subtitle,
                                            breadcrumbds,
                                            scrollToDivRef,
                                            dropdownData,
                                            dropdownBackButtonText,
                                            dropdownBackButtonLink,
                                            titleRef,
                                            heroTitle,
                                            isEmbeddedPage = false,
                                            isUpgrade = false,
                                            rating
                                        }){

    const scrollToDiv = () => {
        scrollToDivRef?.current?.scrollIntoView({ behavior: 'smooth' });
    };

    const isHeroVideo = [
        'video/mp4',     // MP4
        'video/webm',    // WebM
        'video/ogg',     // Ogg
        'video/quicktime', // MOV
        'video/x-msvideo', // AVI
        'video/x-ms-wmv',  // WMV
        'video/x-flv',   // FLV
        'video/mpeg',    // MPEG
        'video/3gpp',    // 3GPP
        'video/3gpp2',   // 3GPP2
        'video/x-matroska', // MKV
        'video/vnd.dlna.mpeg-tts', // DLNA MPEG-TS
        'application/vnd.apple.mpegurl', // HLS (M3U8)
        'video/x-m4v'    // M4V
    ].includes(heroMedia?.[0]?.mime);

    return (
        <MainContentWrapper $isEmbeddedPage={isEmbeddedPage}>
            <div className={'container_header'} style={{
                marginBottom: '35px',
            }}>
                <div style={{position: 'relative'}}>
                    <div className={'desktop_only'}>
                        <CustomDropdown
                            items={dropdownData}
                            backButtonText={dropdownBackButtonText}
                            backButtonLink={dropdownBackButtonLink}
                        />
                    </div>

                    <div>
                        <h1 style={{
                            zIndex:9,
                            position:'absolute',
                            left:'30px',
                            bottom:'250px',
                            font:'38px/50px Playfair Display',
                            color:'white',
                        }}>{heroTitle}</h1>
                        {(isUpgrade && rating) && <div style={{
                            zIndex:9,
                            position:'absolute',
                            left:'30px',
                            bottom:'200px',
                        }}>
                            <Stars size={30} numOfStars={rating ?? 0}/>
                        </div>}
                    </div>


                    <div style={
                        isEmbeddedPage ?
                            {
                                position: "absolute",
                                left: '-50px',
                                top: '250px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '10px',
                                marginBottom: '40px',
                            }
                            :
                            {
                                position: "absolute",
                                left: '-50px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '10px',
                                marginBottom: '40px',
                            }
                    }>
                        {socialLinks?.map((item, index) => {
                            return <SocialLink
                                key={index}
                                style={{}}
                                href={item?.url}
                                target={'_blank'}
                            >
                                <Image key={index} width={25} height={25} src={item?.darkImage?.url}
                                       alt={item?.darkImage?.alt ?? item?.darkImage?.name ?? 'Social Link'}
                                       style={{
                                           width: 'auto',
                                           height: 'auto',
                                       }}/>
                            </SocialLink>
                        })}
                    </div>


                    {
                        !isEmbeddedPage && <div
                            onClick={scrollToDiv}
                            style={{
                                position: 'absolute',
                                left: '-35px',
                                bottom: 0,
                                "WebkitTransform": "rotate(180deg)",
                                "MozTransform": "rotate(180deg)",
                                "MsTransform": "rotate(180deg)",
                                "OTransform": "rotate(180deg)",
                                "transform": "rotate(180deg)",
                                "textTransform": "uppercase",
                                "letterSpacing": "1px",
                                "font": "14px JosefinSans-Regular",
                                "writingMode": "vertical-lr",
                                "display": "flex",
                                "alignItems": "center",
                                "textOrientation": "mixed",
                                "cursor": "pointer"
                            }}
                        >
                            <div style={{
                                color: getColor('lightGreen'),
                                display: 'flex',
                                alignItems: 'center',
                                gap: '30px',
                                lineHeight: 0,
                            }}>
                                <Image src={ArrowDownGreenIcon} alt={'Arrow Down'} style={{
                                    transform: 'rotate(180deg)'
                                }}/>
                                SCROLL DOWN
                            </div>
                        </div>
                    }


                    {
                        isHeroVideo && (
                            <VideoWrapper>
                                {/* Review overlay for larger screens */}
                                <div
                                    className="desktop_only"
                                    style={{
                                        pointerEvents:'none',
                                        position: "absolute",
                                        width: "100%",
                                        bottom: '0',
                                        left: 0,
                                        zIndex: 3, // Ensure this is above everything else
                                    }}
                                >
                                    <ReviewOverlay data={reviewOverlayData} showMobile={false} />
                                </div>
                                <video
                                    key={heroMedia?.[0]?.url}
                                    ref={(videoElement) => {
                                        if (videoElement) {
                                            setTimeout(() => {
                                                videoElement.play().catch((err) => {
                                                    console.error("Video play failed", err);
                                                });
                                            }, 500); // Delay autoplay by 500ms
                                        }
                                    }}
                                    loop
                                    muted
                                    playsInline
                                    preload="metadata"
                                    controls={true}
                                    poster={'/images/video_default_poster.jpg'}
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        zIndex: 1, // Ensure the video is in the background
                                    }}
                                >
                                    <source src={heroMedia?.[0]?.url} type={heroMedia?.[0]?.mime} />
                                    Your browser does not support the video tag.
                                </video>
                            </VideoWrapper>
                        )
                    }


                    {!isHeroVideo && <HeroCarousel
                            images={heroMedia}
                        >
                            {/* Overlay */}
                            <div
                                style={{
                                    pointerEvents: 'none',
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.0) 46%, rgba(0, 0, 0, 0.22) 58%, rgba(0, 0, 0, 0.45) 100%)",
                                    zIndex: 1, // Ensure the overlay sits above the content
                                }}
                            />



                            {/* Review overlay for larger screens */}
                            <div
                                className="desktop_only"
                                style={{
                                    pointerEvents:'none',
                                    position: "absolute",
                                    width: "100%",
                                    bottom: '0',
                                    left: 0,
                                    zIndex: 3, // Ensure this is above everything else
                                }}
                            >
                                <ReviewOverlay data={reviewOverlayData} showMobile={false} />
                            </div>
                        </HeroCarousel>
                    }

                    {/* Review overlay for mobile */}
                    <div className="mobile_only" style={{ zIndex: 3 }}>
                        {/* Ensure this is above everything else */}
                        <ReviewOverlay data={reviewOverlayData} showMobile={false} />
                    </div>

                </div>
                {
                    isEmbeddedPage ?
                        <div ref={titleRef}>
                            <Container className={'container_small'}
                                $isEmbeddedPage={isEmbeddedPage}
                            >
                                <h1 style={{
                                    fontFamily: "system-ui",
                                    fontWeight: 400,
                                    marginTop: '30px',
                                    marginBottom: '20px',
                                }}>{title}</h1>

                                <Breadcrumbs items={breadcrumbds}/>
                            </Container>
                        </div>
                        :
                        <div ref={titleRef}>
                            <div className={'container_small_with_padding_20'}>
                                <div style={{padding:'0 20px'}}>
                                    <h2 style={{
                                        fontFamily: "system-ui",
                                        fontWeight: 400,
                                        marginTop: '30px',
                                        marginBottom: '20px',
                                    }}>{title}</h2>

                                    <Breadcrumbs items={breadcrumbds}/>
                                </div>
                            </div>
                        </div>
                }


                {
                    !isEmbeddedPage && <ReviewOverlay data={reviewOverlayData} showDesktop={false}/>
                }

            </div>
        </MainContentWrapper>


    );

}
